import Educationsvg from '../assets/svg/edu-skills.svg';
import Websvg from '../assets/svg/web-skills.svg';
import progsvg from '../assets/svg/prog-skills.svg';

import htmlcsssvg from '../assets/svg/htmlcss-skills.svg';
import jssvg from '../assets/svg/js-skills.svg';
import nodejssvg from '../assets/svg/nodejs-skills.svg';
import cpp from '../assets/svg/cpp-skills.svg';
import react from '../assets/svg/react-skills.svg';
import reactNative from '../assets/svg/reactnative-skills.svg';
import git from '../assets/svg/git-skills.svg';
import github from '../assets/svg/github-skills.svg';
import mongo from '../assets/svg/mongo-skills.svg';
import mysql from '../assets/svg/mysql-skills.svg';
import python from '../assets/svg/python-skills.svg';
import java from '../assets/svg/java-skills.svg';
import csharp from '../assets/svg/csharp-skills.svg';
import spring from '../assets/svg/spring-skills.svg';
import terraform from '../assets/svg/terraform-skills.svg';
import aws from '../assets/svg/aws-skills.svg';

export const backgroundData = [
    {
        title: "EDUCATION",
        desc: "I completed my Bachelor’s degree in Computer Science from JSS Academy of Technical Education, Noida, graduating with a CGPA of 8.56. My academic training built a strong foundation in core computer science principles, including algorithms, operating systems, computer networks, databases, and object-oriented design. In my final year, I worked on a machine learning research project that resulted in an IEEE publication, giving me hands-on exposure to research-driven development and analytical problem-solving.",
        photo: Educationsvg
    },
    {
        title: "EXPERIENCE",
        desc: "I began my career with internships working across the MERN stack and React Native, contributing to a production mobile application deployed on the Google Play Store. Got an early exposure to building and shipping real user-facing features. I currently work as an SDE at a product-based MNC, developing and optimizing backend systems in the telecom billing domain. My work includes designing serverless and ECS-based microservices, building high-performance invoice rendering tools and reporting interfaces, and improving system reliability through caching, load balancing, and query optimization - delivering measurable gains in performance and scalability.",
        photo: progsvg
    },
    {
        title: "ALGORITHMS & ME",
        desc: "I actively practice data structures and algorithms, having solved 800+ problems across platforms like LeetCode and GeeksforGeeks. I’ve achieved a maximum contest rating of 1745, placing me among the top 17% of competitive programmers globally. Beyond DSA, I have a strong interest in scalable systems and distributed computing. I’m currently focused on learning system design principles and software architectures, with an emphasis on building systems that scale reliably under real-world constraints.",
        photo: Websvg
    }
];

export const skillData = [
    
    {
        title: "Java",
        icon: java,
        percentage: "70"
    },
    {
        title: "Spring Boot",
        icon: spring,
        percentage: "40"
    },
    {
        title: "AWS",
        icon: aws,
        percentage: "40"
    },
    {
        title: "Terraform",
        icon: terraform,
        percentage: "60"
    },
    {
        title: "C++",
        icon: cpp,
        percentage: "70"
    },
    {
        title: "C#",
        icon: csharp,
        percentage: "60"
    },
    {
        title: "Javascript",
        icon: jssvg,
        percentage: "50"
    },
    {
        title: "React JS",
        icon: react,
        percentage: "50"
    },
    {
        title: "Node JS",
        icon: nodejssvg,
        percentage: "40"
    },
    {
        title: "HTML/CSS",
        icon: htmlcsssvg,
        percentage: "80"
    },
    {
        title: "Mongo DB",
        icon: mongo,
        percentage: "40"
    },
    {
        title: "MY SQL",
        icon: mysql,
        percentage: "70"
    },
    {
        title: "Git",
        icon: git,
        percentage: "60"
    },
    {
        title: "Github",
        icon: github,
        percentage: "60"
    },
    {
        title: "React Native",
        icon: reactNative,
        percentage: "30"
    },
    {
        title: "Python",
        icon: python,
        percentage: "20"
    },
]